export default __webpack_public_path__ + "static/media/other_apps_icon.3434ef57.svg";